<template lang="pug">
modal-window.modal-study-complete(:width='500', :height='350', :clickToClose='false', ref='modal')
  .modal-study-complete__inner
    .modal-study-complete__inner__body
      .modal-study-complete__inner__body__title.text-xlarge
        slot(name='studyCompleteTitle')
    .modal-study-complete__inner__footer
      button-primary.modal-study-complete__inner__footer__button(@click='submitEvent')
        slot(name='submitText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/student/ModalWindow.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'

/**
 * 学習画面完了モーダル
 */
@Component({
  components: {
    ModalWindow,
    ButtonPrimary,
  },
})
export default class ModalStudyComplete extends Vue {
  // 完了ボタン押下時イベント
  @Prop()
  submitEvent!: Function

  @Ref() modal!: ModalWindow

  public show() {
    this.modal.show()
  }
}
</script>

<style lang="stylus" scoped>
.modal-study-complete
  text-align center
  &__inner
    &__body
      display flex
      align-items center
      justify-content center
      padding 20px
      height 290px
      &__title
        border-top var(--color-modal-study-complete-title__border) 3px solid
        border-bottom var(--color-modal-study-complete-title__border) 3px solid
        background-color var(--color-modal-study-complete-title__background)
        padding 20px
        width 100%
    &__footer
      position absolute
      display flex
      justify-content center
      bottom 0
      padding 5px 0 15px
      width 100%
      &__button
        width 50%
</style>
